import React from 'react';
import clsx from 'clsx';

import HomeSharpIcon from '@mui/icons-material/HomeSharp';

import './Pointer.scss';
import { COLOR_PRIMARY_DARK } from 'src/const';

const CompsetPointer = ({
  lat,
  lng,
  listingID,
  isUserListing,
  hoveredCompListingID,
}: {
  lat: number;
  lng: number;
  listingID: string;
  isUserListing: boolean;
  hoveredCompListingID: string;
}) => {
  return (
    <>
      {isUserListing ? (
        <HomeSharpIcon
          sx={{
            fontSize: 40,
            color: COLOR_PRIMARY_DARK,
            cursor: 'pointer',
          }}
        />
      ) : (
        <div
          className={clsx('pointer-compset', {
            'pointer-compset-active': hoveredCompListingID === listingID,
          })}
        ></div>
      )}
    </>
  );
};

export default React.memo(CompsetPointer);
